/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * field to filter for diffusion list search:
 *   * NAME : the diffusion list's name
 *   * TYPE : the diffusion list's type
 *   * STATION : the diffusion list's station's uid
 */
export enum DiffusionListSearchFilter {
  NAME = 'NAME',
  TYPE = 'TYPE',
  STATION = 'STATION'
}
